























import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import RequiredLabel from '@/components/ui/RequiredLabel.vue';
import {questionCollectionModule} from '@/store/modules';
import {SelectItem} from '@/interfaces';
import {rulesRequired} from '@/utility';
import {InputValidationRules} from 'vuetify';

@Component({components: {RequiredLabel}})
export default class QuestionCollectionAutocomplete extends Vue {
  @Prop() value!: string;
  private rules: InputValidationRules = rulesRequired;

  get list(): SelectItem[] {
    return questionCollectionModule.list.map(item => ({
      text: item.attributes.label,
      value: item.id,
    }));
  }

  get listing(): boolean {
    return questionCollectionModule.listing;
  }

  async created(): Promise<void> {
    await questionCollectionModule.loadMulti();
  }

  update(value: string): void {
    this.$emit('input', value);
  }
}
